import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';

import { GridColSelect } from '@shared/components/grid/GridColSelect';
import { GridColTextInput } from '@shared/components/grid/GridColTextInput';
import { gridPhoneCell, gridZipCell, dataGridCol } from '@shared/components/grid/common';
import { IMap } from '@shared/interfaces';

import { statesList } from '@shared/constants/statesList';
import { ContactSection } from '../ContactSection';
import { NContact } from '../../validation';
import { relationshipTypes } from '../../interfaces';
import { contactReferenceValidationSchema } from './validation';

interface IReferencesProps {
  data?: NContact.Reference[];
  onChange(data: NContact.Reference[]): Promise<IMap<string> | undefined>;
}

export const References = ({ data = [], onChange }: IReferencesProps) => {
  const columns: GridColDef<NContact.Reference>[] = useMemo(
    () =>
      [
        dataGridCol('fullName', { minWidth: 150, flex: 1 }),
        dataGridCol('phoneNumber', { ...gridPhoneCell, minWidth: 80, flex: 0.8 }),
        dataGridCol('emailAddress', { minWidth: 120, flex: 1.2 }),
        dataGridCol('streetLine1', { headerName: 'Address',  minWidth: 100, flex: 2 , textWrap: true}),
        dataGridCol('city', { minWidth: 100, flex: 0.8 }),
        dataGridCol('state', {
          minWidth: 50,
          flex: 0.5,
          editable: true,
					renderEditCell: (params) => (
            <GridColSelect isSearchable canBeClean={false} params={params} options={statesList} />
          )
        }),
        dataGridCol('zip', {
          ...gridZipCell,
          minWidth: 70,
          flex: 0.7,
          textWrap: true,
        }),
        dataGridCol('relationshipType', {
          headerName: 'Relationship',
          flex: 1,
          minWidth: 120,
          renderEditCell: (params) => (
            <GridColSelect 
              isSearchable 
              canBeClean={false} 
              options={relationshipTypes} 
              params={params} 
            />
          ),
          renderCell: (params) => (
            <GridColSelect 
              options={relationshipTypes} 
              params={params} 
            />
          ),
        }),
      ].map((i) => ({ renderEditCell: (params) => <GridColTextInput params={params} />, ...i, sortable: false, disableColumnMenu: true, editable: true })),
    []
  );

  return useMemo(() => <ContactSection
    name="Reference"
    buttonTitle="+ New"
    data={data}
    columns={columns}
    validateSchema={contactReferenceValidationSchema}
    onChange={onChange}
  />, [data]);
};
